<template>
  <error text="404! PAGINA NO ENCONTRADA" />
</template>

<script>
import error from "../../components/shared/error/error.vue";
export default {
  components: {
    error,
  },
  // name: "404",
};
</script>